import { useContext } from "react";
import AuthContext from "../store/auth-context";

 export const useRole=()=> {
  const authCtx = useContext(AuthContext)
  const role = authCtx.role
    console.log(role)
   
   return role
  }


